import React from 'react';
import TemplateCollections from '../../components/crm/TemplateCollections';

// Sales starts with one empty section; staff add their own from the page.
const DEFAULT_SALES_SECTIONS = [{ id: 'general', label: 'General', items: [] }];

const SALES_CONFIG = {
  title: 'Sales Materials',
  pillar: 'Sales',
  structureId: 'sales',
  defaultSections: DEFAULT_SALES_SECTIONS,
  backTo: '/crm/templates',
  accent: {
    tabActive: 'bg-red-600',
    spinner: 'border-red-600',
    button: 'bg-red-600 hover:bg-red-700',
  },
  sectionPlaceholder: 'e.g. Scripts',
  itemPlaceholder: 'e.g. Discovery Call Script',
  showCanvaLink: true,
};

const SalesCollections = () => <TemplateCollections config={SALES_CONFIG} />;

export default SalesCollections;
